// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as MainRouteRouteImport } from './routes/_main/route'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as DashboardDashboardRouteImport } from './routes/_dashboard/dashboard'
import { Route as MainIndexRouteImport } from './routes/_main/index'
import { Route as MainContactRouteImport } from './routes/_main/contact'
import { Route as MainDataDeletionRouteImport } from './routes/_main/data-deletion'
import { Route as MainPrivacyRouteImport } from './routes/_main/privacy'
import { Route as MainTermsRouteImport } from './routes/_main/terms'
import { Route as ExportLaserFlowRouteImport } from './routes/export/laser-flow'
import { Route as DashboardDashboardIndexRouteImport } from './routes/_dashboard/dashboard/index'
import { Route as DashboardDashboardAccountsRouteRouteImport } from './routes/_dashboard/dashboard/accounts/route'
import { Route as DashboardDashboardBankAccountsRouteRouteImport } from './routes/_dashboard/dashboard/bank-accounts/route'
import { Route as DashboardDashboardBankConnectionsRouteRouteImport } from './routes/_dashboard/dashboard/bank-connections/route'
import { Route as DashboardDashboardBankTransactionsRouteRouteImport } from './routes/_dashboard/dashboard/bank-transactions/route'
import { Route as DashboardDashboardBusinessRouteImport } from './routes/_dashboard/dashboard/business'
import { Route as DashboardDashboardChatRouteRouteImport } from './routes/_dashboard/dashboard/chat/route'
import { Route as DashboardDashboardDocumentsRouteRouteImport } from './routes/_dashboard/dashboard/documents/route'
import { Route as DashboardDashboardFixedAssetsRouteRouteImport } from './routes/_dashboard/dashboard/fixed-assets/route'
import { Route as DashboardDashboardJournalEntriesRouteRouteImport } from './routes/_dashboard/dashboard/journal-entries/route'
import { Route as DashboardDashboardProfileRouteImport } from './routes/_dashboard/dashboard/profile'
import { Route as DashboardDashboardReportsRouteRouteImport } from './routes/_dashboard/dashboard/reports/route'
import { Route as DashboardDashboardSettingsRouteRouteImport } from './routes/_dashboard/dashboard/settings/route'
import { Route as DashboardDashboardVendorsRouteRouteImport } from './routes/_dashboard/dashboard/vendors/route'
import { Route as DashboardDashboardWorksheetsRouteRouteImport } from './routes/_dashboard/dashboard/worksheets/route'
import { Route as DashboardDashboardAccountsIndexRouteImport } from './routes/_dashboard/dashboard/accounts/index'
import { Route as DashboardDashboardAccountsAccountIdRouteImport } from './routes/_dashboard/dashboard/accounts/$accountId'
import { Route as DashboardDashboardAdminPricingSimulatorRouteImport } from './routes/_dashboard/dashboard/admin/pricing-simulator'
import { Route as DashboardDashboardBankAccountsIndexRouteImport } from './routes/_dashboard/dashboard/bank-accounts/index'
import { Route as DashboardDashboardBankAccountsBankAccountIdRouteImport } from './routes/_dashboard/dashboard/bank-accounts/$bankAccountId'
import { Route as DashboardDashboardBankConnectionsIndexRouteImport } from './routes/_dashboard/dashboard/bank-connections/index'
import { Route as DashboardDashboardBankTransactionsIndexRouteImport } from './routes/_dashboard/dashboard/bank-transactions/index'
import { Route as DashboardDashboardBankTransactionsTransactionIdRouteImport } from './routes/_dashboard/dashboard/bank-transactions/$transactionId'
import { Route as DashboardDashboardChatIndexRouteImport } from './routes/_dashboard/dashboard/chat/index'
import { Route as DashboardDashboardChatSessionIdRouteImport } from './routes/_dashboard/dashboard/chat/$sessionId'
import { Route as DashboardDashboardDocumentsIndexRouteImport } from './routes/_dashboard/dashboard/documents/index'
import { Route as DashboardDashboardDocumentsDocumentIdRouteImport } from './routes/_dashboard/dashboard/documents/$documentId'
import { Route as DashboardDashboardFixedAssetsIndexRouteImport } from './routes/_dashboard/dashboard/fixed-assets/index'
import { Route as DashboardDashboardFixedAssetsFixedAssetIdRouteImport } from './routes/_dashboard/dashboard/fixed-assets/$fixedAssetId'
import { Route as DashboardDashboardJournalEntriesIndexRouteImport } from './routes/_dashboard/dashboard/journal-entries/index'
import { Route as DashboardDashboardJournalEntriesJournalEntryIdRouteImport } from './routes/_dashboard/dashboard/journal-entries/$journalEntryId'
import { Route as DashboardDashboardReportsIndexRouteImport } from './routes/_dashboard/dashboard/reports/index'
import { Route as DashboardDashboardReportsBalanceSheetRouteImport } from './routes/_dashboard/dashboard/reports/balance-sheet'
import { Route as DashboardDashboardReportsPAndLRouteImport } from './routes/_dashboard/dashboard/reports/p-and-l'
import { Route as DashboardDashboardSettingsAiRouteImport } from './routes/_dashboard/dashboard/settings/ai'
import { Route as DashboardDashboardSettingsBillingRouteImport } from './routes/_dashboard/dashboard/settings/billing'
import { Route as DashboardDashboardVendorsIndexRouteImport } from './routes/_dashboard/dashboard/vendors/index'
import { Route as DashboardDashboardVendorsVendorIdRouteImport } from './routes/_dashboard/dashboard/vendors/$vendorId'
import { Route as DashboardDashboardWorksheetsIndexRouteImport } from './routes/_dashboard/dashboard/worksheets/index'
import { Route as DashboardDashboardWorksheetsWorksheetIdRouteImport } from './routes/_dashboard/dashboard/worksheets/$worksheetId'

const DashboardRoute = DashboardRouteImport.update({
            id: '/_dashboard',getParentRoute: () => rootRouteImport
          })
const MainRouteRoute = MainRouteRouteImport.update({
            id: '/_main',getParentRoute: () => rootRouteImport
          })
const ErrorRoute = ErrorRouteImport.update({
            id: '/error',path: '/error',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const DashboardDashboardRoute = DashboardDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => DashboardRoute
          })
const MainIndexRoute = MainIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MainRouteRoute
          })
const MainContactRoute = MainContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => MainRouteRoute
          })
const MainDataDeletionRoute = MainDataDeletionRouteImport.update({
            id: '/data-deletion',path: '/data-deletion',getParentRoute: () => MainRouteRoute
          })
const MainPrivacyRoute = MainPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => MainRouteRoute
          })
const MainTermsRoute = MainTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => MainRouteRoute
          })
const ExportLaserFlowRoute = ExportLaserFlowRouteImport.update({
            id: '/export/laser-flow',path: '/export/laser-flow',getParentRoute: () => rootRouteImport
          })
const DashboardDashboardIndexRoute = DashboardDashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardDashboardRoute
          })
const DashboardDashboardAccountsRouteRoute = DashboardDashboardAccountsRouteRouteImport.update({
            id: '/accounts',path: '/accounts',getParentRoute: () => DashboardDashboardRoute
          })
const DashboardDashboardBankAccountsRouteRoute = DashboardDashboardBankAccountsRouteRouteImport.update({
            id: '/bank-accounts',path: '/bank-accounts',getParentRoute: () => DashboardDashboardRoute
          })
const DashboardDashboardBankConnectionsRouteRoute = DashboardDashboardBankConnectionsRouteRouteImport.update({
            id: '/bank-connections',path: '/bank-connections',getParentRoute: () => DashboardDashboardRoute
          })
const DashboardDashboardBankTransactionsRouteRoute = DashboardDashboardBankTransactionsRouteRouteImport.update({
            id: '/bank-transactions',path: '/bank-transactions',getParentRoute: () => DashboardDashboardRoute
          })
const DashboardDashboardBusinessRoute = DashboardDashboardBusinessRouteImport.update({
            id: '/business',path: '/business',getParentRoute: () => DashboardDashboardRoute
          })
const DashboardDashboardChatRouteRoute = DashboardDashboardChatRouteRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => DashboardDashboardRoute
          })
const DashboardDashboardDocumentsRouteRoute = DashboardDashboardDocumentsRouteRouteImport.update({
            id: '/documents',path: '/documents',getParentRoute: () => DashboardDashboardRoute
          })
const DashboardDashboardFixedAssetsRouteRoute = DashboardDashboardFixedAssetsRouteRouteImport.update({
            id: '/fixed-assets',path: '/fixed-assets',getParentRoute: () => DashboardDashboardRoute
          })
const DashboardDashboardJournalEntriesRouteRoute = DashboardDashboardJournalEntriesRouteRouteImport.update({
            id: '/journal-entries',path: '/journal-entries',getParentRoute: () => DashboardDashboardRoute
          })
const DashboardDashboardProfileRoute = DashboardDashboardProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => DashboardDashboardRoute
          })
const DashboardDashboardReportsRouteRoute = DashboardDashboardReportsRouteRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => DashboardDashboardRoute
          })
const DashboardDashboardSettingsRouteRoute = DashboardDashboardSettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => DashboardDashboardRoute
          })
const DashboardDashboardVendorsRouteRoute = DashboardDashboardVendorsRouteRouteImport.update({
            id: '/vendors',path: '/vendors',getParentRoute: () => DashboardDashboardRoute
          })
const DashboardDashboardWorksheetsRouteRoute = DashboardDashboardWorksheetsRouteRouteImport.update({
            id: '/worksheets',path: '/worksheets',getParentRoute: () => DashboardDashboardRoute
          })
const DashboardDashboardAccountsIndexRoute = DashboardDashboardAccountsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardDashboardAccountsRouteRoute
          })
const DashboardDashboardAccountsAccountIdRoute = DashboardDashboardAccountsAccountIdRouteImport.update({
            id: '/$accountId',path: '/$accountId',getParentRoute: () => DashboardDashboardAccountsRouteRoute
          })
const DashboardDashboardAdminPricingSimulatorRoute = DashboardDashboardAdminPricingSimulatorRouteImport.update({
            id: '/admin/pricing-simulator',path: '/admin/pricing-simulator',getParentRoute: () => DashboardDashboardRoute
          })
const DashboardDashboardBankAccountsIndexRoute = DashboardDashboardBankAccountsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardDashboardBankAccountsRouteRoute
          })
const DashboardDashboardBankAccountsBankAccountIdRoute = DashboardDashboardBankAccountsBankAccountIdRouteImport.update({
            id: '/$bankAccountId',path: '/$bankAccountId',getParentRoute: () => DashboardDashboardBankAccountsRouteRoute
          })
const DashboardDashboardBankConnectionsIndexRoute = DashboardDashboardBankConnectionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardDashboardBankConnectionsRouteRoute
          })
const DashboardDashboardBankTransactionsIndexRoute = DashboardDashboardBankTransactionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardDashboardBankTransactionsRouteRoute
          })
const DashboardDashboardBankTransactionsTransactionIdRoute = DashboardDashboardBankTransactionsTransactionIdRouteImport.update({
            id: '/$transactionId',path: '/$transactionId',getParentRoute: () => DashboardDashboardBankTransactionsRouteRoute
          })
const DashboardDashboardChatIndexRoute = DashboardDashboardChatIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardDashboardChatRouteRoute
          })
const DashboardDashboardChatSessionIdRoute = DashboardDashboardChatSessionIdRouteImport.update({
            id: '/$sessionId',path: '/$sessionId',getParentRoute: () => DashboardDashboardChatRouteRoute
          })
const DashboardDashboardDocumentsIndexRoute = DashboardDashboardDocumentsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardDashboardDocumentsRouteRoute
          })
const DashboardDashboardDocumentsDocumentIdRoute = DashboardDashboardDocumentsDocumentIdRouteImport.update({
            id: '/$documentId',path: '/$documentId',getParentRoute: () => DashboardDashboardDocumentsRouteRoute
          })
const DashboardDashboardFixedAssetsIndexRoute = DashboardDashboardFixedAssetsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardDashboardFixedAssetsRouteRoute
          })
const DashboardDashboardFixedAssetsFixedAssetIdRoute = DashboardDashboardFixedAssetsFixedAssetIdRouteImport.update({
            id: '/$fixedAssetId',path: '/$fixedAssetId',getParentRoute: () => DashboardDashboardFixedAssetsRouteRoute
          })
const DashboardDashboardJournalEntriesIndexRoute = DashboardDashboardJournalEntriesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardDashboardJournalEntriesRouteRoute
          })
const DashboardDashboardJournalEntriesJournalEntryIdRoute = DashboardDashboardJournalEntriesJournalEntryIdRouteImport.update({
            id: '/$journalEntryId',path: '/$journalEntryId',getParentRoute: () => DashboardDashboardJournalEntriesRouteRoute
          })
const DashboardDashboardReportsIndexRoute = DashboardDashboardReportsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardDashboardReportsRouteRoute
          })
const DashboardDashboardReportsBalanceSheetRoute = DashboardDashboardReportsBalanceSheetRouteImport.update({
            id: '/balance-sheet',path: '/balance-sheet',getParentRoute: () => DashboardDashboardReportsRouteRoute
          })
const DashboardDashboardReportsPAndLRoute = DashboardDashboardReportsPAndLRouteImport.update({
            id: '/p-and-l',path: '/p-and-l',getParentRoute: () => DashboardDashboardReportsRouteRoute
          })
const DashboardDashboardSettingsAiRoute = DashboardDashboardSettingsAiRouteImport.update({
            id: '/ai',path: '/ai',getParentRoute: () => DashboardDashboardSettingsRouteRoute
          })
const DashboardDashboardSettingsBillingRoute = DashboardDashboardSettingsBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => DashboardDashboardSettingsRouteRoute
          })
const DashboardDashboardVendorsIndexRoute = DashboardDashboardVendorsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardDashboardVendorsRouteRoute
          })
const DashboardDashboardVendorsVendorIdRoute = DashboardDashboardVendorsVendorIdRouteImport.update({
            id: '/$vendorId',path: '/$vendorId',getParentRoute: () => DashboardDashboardVendorsRouteRoute
          })
const DashboardDashboardWorksheetsIndexRoute = DashboardDashboardWorksheetsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardDashboardWorksheetsRouteRoute
          })
const DashboardDashboardWorksheetsWorksheetIdRoute = DashboardDashboardWorksheetsWorksheetIdRouteImport.update({
            id: '/$worksheetId',path: '/$worksheetId',getParentRoute: () => DashboardDashboardWorksheetsRouteRoute
          })





const MainRouteRouteChildren = {
  MainContactRoute: MainContactRoute,MainDataDeletionRoute: MainDataDeletionRoute,MainPrivacyRoute: MainPrivacyRoute,MainTermsRoute: MainTermsRoute,MainIndexRoute: MainIndexRoute
}

const MainRouteRouteWithChildren = MainRouteRoute._addFileChildren(MainRouteRouteChildren)




const DashboardDashboardAccountsRouteRouteChildren = {
  DashboardDashboardAccountsAccountIdRoute: DashboardDashboardAccountsAccountIdRoute,DashboardDashboardAccountsIndexRoute: DashboardDashboardAccountsIndexRoute
}

const DashboardDashboardAccountsRouteRouteWithChildren = DashboardDashboardAccountsRouteRoute._addFileChildren(DashboardDashboardAccountsRouteRouteChildren)




const DashboardDashboardBankAccountsRouteRouteChildren = {
  DashboardDashboardBankAccountsBankAccountIdRoute: DashboardDashboardBankAccountsBankAccountIdRoute,DashboardDashboardBankAccountsIndexRoute: DashboardDashboardBankAccountsIndexRoute
}

const DashboardDashboardBankAccountsRouteRouteWithChildren = DashboardDashboardBankAccountsRouteRoute._addFileChildren(DashboardDashboardBankAccountsRouteRouteChildren)




const DashboardDashboardBankConnectionsRouteRouteChildren = {
  DashboardDashboardBankConnectionsIndexRoute: DashboardDashboardBankConnectionsIndexRoute
}

const DashboardDashboardBankConnectionsRouteRouteWithChildren = DashboardDashboardBankConnectionsRouteRoute._addFileChildren(DashboardDashboardBankConnectionsRouteRouteChildren)




const DashboardDashboardBankTransactionsRouteRouteChildren = {
  DashboardDashboardBankTransactionsTransactionIdRoute: DashboardDashboardBankTransactionsTransactionIdRoute,DashboardDashboardBankTransactionsIndexRoute: DashboardDashboardBankTransactionsIndexRoute
}

const DashboardDashboardBankTransactionsRouteRouteWithChildren = DashboardDashboardBankTransactionsRouteRoute._addFileChildren(DashboardDashboardBankTransactionsRouteRouteChildren)




const DashboardDashboardChatRouteRouteChildren = {
  DashboardDashboardChatSessionIdRoute: DashboardDashboardChatSessionIdRoute,DashboardDashboardChatIndexRoute: DashboardDashboardChatIndexRoute
}

const DashboardDashboardChatRouteRouteWithChildren = DashboardDashboardChatRouteRoute._addFileChildren(DashboardDashboardChatRouteRouteChildren)




const DashboardDashboardDocumentsRouteRouteChildren = {
  DashboardDashboardDocumentsDocumentIdRoute: DashboardDashboardDocumentsDocumentIdRoute,DashboardDashboardDocumentsIndexRoute: DashboardDashboardDocumentsIndexRoute
}

const DashboardDashboardDocumentsRouteRouteWithChildren = DashboardDashboardDocumentsRouteRoute._addFileChildren(DashboardDashboardDocumentsRouteRouteChildren)




const DashboardDashboardFixedAssetsRouteRouteChildren = {
  DashboardDashboardFixedAssetsFixedAssetIdRoute: DashboardDashboardFixedAssetsFixedAssetIdRoute,DashboardDashboardFixedAssetsIndexRoute: DashboardDashboardFixedAssetsIndexRoute
}

const DashboardDashboardFixedAssetsRouteRouteWithChildren = DashboardDashboardFixedAssetsRouteRoute._addFileChildren(DashboardDashboardFixedAssetsRouteRouteChildren)




const DashboardDashboardJournalEntriesRouteRouteChildren = {
  DashboardDashboardJournalEntriesJournalEntryIdRoute: DashboardDashboardJournalEntriesJournalEntryIdRoute,DashboardDashboardJournalEntriesIndexRoute: DashboardDashboardJournalEntriesIndexRoute
}

const DashboardDashboardJournalEntriesRouteRouteWithChildren = DashboardDashboardJournalEntriesRouteRoute._addFileChildren(DashboardDashboardJournalEntriesRouteRouteChildren)




const DashboardDashboardReportsRouteRouteChildren = {
  DashboardDashboardReportsBalanceSheetRoute: DashboardDashboardReportsBalanceSheetRoute,DashboardDashboardReportsPAndLRoute: DashboardDashboardReportsPAndLRoute,DashboardDashboardReportsIndexRoute: DashboardDashboardReportsIndexRoute
}

const DashboardDashboardReportsRouteRouteWithChildren = DashboardDashboardReportsRouteRoute._addFileChildren(DashboardDashboardReportsRouteRouteChildren)




const DashboardDashboardSettingsRouteRouteChildren = {
  DashboardDashboardSettingsAiRoute: DashboardDashboardSettingsAiRoute,DashboardDashboardSettingsBillingRoute: DashboardDashboardSettingsBillingRoute
}

const DashboardDashboardSettingsRouteRouteWithChildren = DashboardDashboardSettingsRouteRoute._addFileChildren(DashboardDashboardSettingsRouteRouteChildren)




const DashboardDashboardVendorsRouteRouteChildren = {
  DashboardDashboardVendorsVendorIdRoute: DashboardDashboardVendorsVendorIdRoute,DashboardDashboardVendorsIndexRoute: DashboardDashboardVendorsIndexRoute
}

const DashboardDashboardVendorsRouteRouteWithChildren = DashboardDashboardVendorsRouteRoute._addFileChildren(DashboardDashboardVendorsRouteRouteChildren)




const DashboardDashboardWorksheetsRouteRouteChildren = {
  DashboardDashboardWorksheetsWorksheetIdRoute: DashboardDashboardWorksheetsWorksheetIdRoute,DashboardDashboardWorksheetsIndexRoute: DashboardDashboardWorksheetsIndexRoute
}

const DashboardDashboardWorksheetsRouteRouteWithChildren = DashboardDashboardWorksheetsRouteRoute._addFileChildren(DashboardDashboardWorksheetsRouteRouteChildren)



const DashboardDashboardRouteChildren = {
  DashboardDashboardAccountsRouteRoute: DashboardDashboardAccountsRouteRouteWithChildren,DashboardDashboardBankAccountsRouteRoute: DashboardDashboardBankAccountsRouteRouteWithChildren,DashboardDashboardBankConnectionsRouteRoute: DashboardDashboardBankConnectionsRouteRouteWithChildren,DashboardDashboardBankTransactionsRouteRoute: DashboardDashboardBankTransactionsRouteRouteWithChildren,DashboardDashboardChatRouteRoute: DashboardDashboardChatRouteRouteWithChildren,DashboardDashboardDocumentsRouteRoute: DashboardDashboardDocumentsRouteRouteWithChildren,DashboardDashboardFixedAssetsRouteRoute: DashboardDashboardFixedAssetsRouteRouteWithChildren,DashboardDashboardJournalEntriesRouteRoute: DashboardDashboardJournalEntriesRouteRouteWithChildren,DashboardDashboardReportsRouteRoute: DashboardDashboardReportsRouteRouteWithChildren,DashboardDashboardSettingsRouteRoute: DashboardDashboardSettingsRouteRouteWithChildren,DashboardDashboardVendorsRouteRoute: DashboardDashboardVendorsRouteRouteWithChildren,DashboardDashboardWorksheetsRouteRoute: DashboardDashboardWorksheetsRouteRouteWithChildren,DashboardDashboardBusinessRoute: DashboardDashboardBusinessRoute,DashboardDashboardProfileRoute: DashboardDashboardProfileRoute,DashboardDashboardIndexRoute: DashboardDashboardIndexRoute,DashboardDashboardAdminPricingSimulatorRoute: DashboardDashboardAdminPricingSimulatorRoute
}

const DashboardDashboardRouteWithChildren = DashboardDashboardRoute._addFileChildren(DashboardDashboardRouteChildren)



const DashboardRouteChildren = {
  DashboardDashboardRoute: DashboardDashboardRouteWithChildren
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(DashboardRouteChildren)

const rootRouteChildren = {
  MainRouteRoute: MainRouteRouteWithChildren,DashboardRoute: DashboardRouteWithChildren,ErrorRoute: ErrorRoute,ForgotPasswordRoute: ForgotPasswordRoute,LoginRoute: LoginRoute,ResetPasswordRoute: ResetPasswordRoute,ExportLaserFlowRoute: ExportLaserFlowRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)